import { useSettingEnableVendorDataCollection } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableVendorDataCollection";
import { VENDOR_UPLOAD_LIST_MODAL_SEEN } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/VENDOR_UPLOAD_LIST_MODAL_SEEN";
import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";
import { useRetailerMilestone } from "@faire/web/common/hooks";

import { IGateHook } from "./type";
import { useModalType } from "./useModalType";

export const useVendorUploadListGate: IGateHook = () => {
  const modalType = useModalType();
  const { hasOccurred: hasSeenVendorUploadListModal } = useRetailerMilestone(
    VENDOR_UPLOAD_LIST_MODAL_SEEN
  );
  const isVendorDataCollectionEnabled = useSettingEnableVendorDataCollection();

  if (
    modalType === PromoModalType.VENDOR_UPLOAD_LIST_MODAL &&
    isVendorDataCollectionEnabled &&
    !hasSeenVendorUploadListModal
  ) {
    return PromoModalType.VENDOR_UPLOAD_LIST_MODAL;
  }

  return undefined;
};
